import { colors, fonts, screen } from 'components/styles/variables';
import css from 'styled-jsx/css';

export const contactBarStyles = css`
  .bar {
    width: 100%;
    background-color: white;
    padding: 16px 0;
    font-size: 18px;
    display: flex;
    border-bottom: 1px solid ${colors.G2};
  }
  @media (min-width: ${screen.lgMin}) {
    .bar {
      display: none;
    }
  }
  .button {
    height: 44px;
    font-size: 16px;
    flex-basis: 100%;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-family: ${fonts.default};
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    letter-spacing: 0.2px;
    justify-content: center;
    color: ${colors.WHITE};
    background-color: ${colors.ALR1};
  }
  .button:hover {
    background-color: ${colors.ALR2};
    color: ${colors.WHITE};
  }
`;
